import React from 'react'
import logo from './logo.svg'

export default () => {
    return (
        <header className="layout-header">
            <img className="layout-logo" src={logo} alt="Logo" />
        </header>
    )
}



// WEBPACK FOOTER //
// ./src/layout/header.js